import React, { useEffect, useState, useImperativeHandle,useContext } from "react";
import { Container, Col, Row, Table } from "react-bootstrap";
import { format ,parseISO } from 'date-fns'
import "./PriceHistory.css";
import URLstateContext from "../../../provider/CommonContext";
function PriceHistory(props,ref) {

    let getExchange = props.exchange;
    let getCoCode = props.coCode;


  let getcompname = props.compname;
  let getData, getchartData;
  const [chartdata, setchartData] = useState([]);
  const {BaseURL} = useContext(URLstateContext);
  useImperativeHandle(ref, () => ({
      chnageexchnagepricehistory: (excgh) => {
      
       const getUrlchart = BaseURL + "Company-Chart/";
         fetch(`${getUrlchart}/${excgh}/${getCoCode}/5D`)
        .then((response) => response.json())
        .then((data) => {
          getchartData = data.data;
          setchartData(getchartData);        
        })
        .catch((error) => {
          //console.log("not found the api");
        }); 
        
    }
  }));
    useEffect(() => {
        //console.log("price cocode:" + props.coCode);
        //console.log("price name:" + props.compname);
    const getUrlchart = BaseURL +"Company-Chart/";
        if (getCoCode != "") {
            fetch(`${getUrlchart}${getExchange}/${getCoCode}/5D`)
                .then((response) => response.json())
                .then((data) => {
                    getchartData = data.data;
                    setchartData(getchartData);

                })
                .catch((error) => {
                    //console.log("not found the api");
                });
        }
      

  }, [props.coCode, props.exchange]);
  return (
    <>
      <section className="price-history-section">
        <Container className="table-boxPrice">
          <Row>
            <Col md={12}>
              <h5 className="pricehead">{getcompname} Share Price History</h5>
              <div className="table-responsive">
              <Table striped bordered hover size="sm">
                <thead className="heading">
                  <tr>
                    <th>Date</th>
                    <th>Close</th>
                    <th>Open</th>
                    <th>High</th>
                    <th>Low</th>
                  </tr>
                </thead>
                {(chartdata === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                <tbody >
               
                  {chartdata && chartdata.map(({ upd_Date, price, open, high, low }) => (
                      <>
                        <tr className="tbldata">
                          <th>{(upd_Date != null) ? (format(parseISO(upd_Date), 'dd-MMM-yyyy')):'No Day'}</th>
                          <th>{(price != undefined) ? (price.toFixed(2)) : 0}</th>
                          <th>{(open != undefined) ? (open.toFixed(2)) : 0}</th>
                          <th>{(high != undefined) ? (high.toFixed(2)) : 0}</th>
                          <th>{(low != undefined) ? (low.toFixed(2)) : 0}</th>
                        </tr>
                      </>
                    ))}
                </tbody>
              </Table>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default React.forwardRef(PriceHistory);
